<script lang="ts">
  import {createEventDispatcher, onMount} from 'svelte';
  import Modal from '@/widgets/Modal.svelte';
  import {Button} from '@px/button';
  import {IMAGES, LEGEND_KYC_STATUS_DATA, type LEGEND_KYC_STATUS} from '../utils';
  import {loadLegendKYCStatus$, legendKYCStatus$, LoadLegendKYCStatusPollTimes, stopLoadLegendKYCStatus$} from './streams';
  import lang from '../LegendQuestionnare.lang';

  export let LG;
  export let legendKycStatus: LEGEND_KYC_STATUS;

  const dispatch = createEventDispatcher();

  let pollTimes = 0;

  $: baseInfo = getLegendKYCBaseInfo(legendKycStatus);
  $: refreshLegendKYCStatus(legendKycStatus);
  $: watchLegendKYCStatus($legendKYCStatus$);

  onMount(() => {
    return () => {
      stopLoadLegendKYCStatus$.next();
    };
  });

  function refreshLegendKYCStatus(legendKycStatus: LEGEND_KYC_STATUS) {
    if (legendKycStatus === 'PROCESSING') {
      loadLegendKYCStatus$.next(null);
    }
  }

  function watchLegendKYCStatus(status: LEGEND_KYC_STATUS | 'APPROVED') {
    console.log(status);
    if (!status) {
      return;
    }
    if (legendKycStatus !== 'PROCESSING') {
      stopLoadLegendKYCStatus$.next();
      return;
    }
    if (status === 'APPROVED') {
      dispatch('success');
      stopLoadLegendKYCStatus$.next();
      return;
    }
    if (status === 'REJECTED') {
      legendKycStatus = 'REJECTED';
      stopLoadLegendKYCStatus$.next();
      return;
    }
    pollTimes += 1;
    if (pollTimes >= LoadLegendKYCStatusPollTimes) {
      legendKycStatus = 'IN_REVIEW';
    }
  }

  function getLegendKYCBaseInfo(legendKycStatus: LEGEND_KYC_STATUS) {
    const dataMaps: Record<Exclude<LEGEND_KYC_STATUS, 'WRITE_QUESTIONNAIRE'>, {logo: string; title: any; introduction?: any; content?: any; showConfirm?: Boolean}> = {
      REJECTED: {
        logo: IMAGES.ORDER_FAILED,
        title: lang.Unfortunately,
        introduction: lang.UnfortunatelyTitle,
        content: lang.UnfortunatelyIntroduction,
        showConfirm: true,
      },
      PROCESSING: {
        logo: IMAGES.ORDER_PROCESSING,
        title: lang.KYCLoadingTitle,
        content: lang.KYCLoadingIntroduction,
        showConfirm: true,
      },
      IN_REVIEW: {
        logo: IMAGES.ORDER_TIME,
        title: lang.VerifyYourIdentity,
        introduction: lang.VerifyYourIdentityTitle,
        content: lang.VerifyYourIdentityIntroduction,
        showConfirm: true,
      },
    };
    return dataMaps[legendKycStatus];
  }

  function handleConfirmClick() {
    dispatch('close');
  }
</script>

<style lang="scss">
  .dialog-box {
    :global(.submit-btn) {
      height: 56px;
    }
  }
  .light-color {
    color: rgba(29, 33, 41, 0.65);
  }
  .gilroy {
    font-family: Gilroy;
  }
  .bg {
    border-radius: 6px;
    padding: 12px 8px;
    background: var(--CARD1);
  }
  .content :global(button.primary) {
    background: var(--BTN-BG);
    color: var(--BTN-COLOR);
    border-color: var(--BTN-BG);
    border-radius: 32px;
  }
</style>

<div class="dialog-box" on:mousewheel|preventDefault>
  <Modal class="order-container" visible showCloseIcon on:close allowScroll style="width: 480px">
    <div class="df aic jcc fdc content">
      <img src="https://img.phemex.com/v1/40fd3a31-3ba0-494c-a847-ff317b2c8333/processing.svg" width="88" height="88" alt="" srcset="" />
      <h1 class="p0 T1 f20 b gilroy mt32">{LG(baseInfo.title)}</h1>
      <div class="light-color f16 fw2 gilroy mt12" hidden={!baseInfo.introduction}>{LG(baseInfo.introduction)}</div>
      <div class="light-color gilroy {!!baseInfo.introduction ? 'f12 bg' : 'f16 fw2'} mt12" style="color: #6C6E74;text-align: center" hidden={!baseInfo.content}>
        {@html LG(baseInfo.content, {
          OneMinute: `<span class="b T1">${LG(lang.OneMinute)}</span>`,
          SubmitATicket: `<a href="https://support.legendtrading.com/hc/en-us/requests/new" target="legend_support">Submit a Ticket</a>`,
        })}
      </div>
      {#if baseInfo.showConfirm}
        <Button newRadius type="primary" class="submit-btn mt32 wp100 f16 fw2" on:click={handleConfirmClick}>
          {LG(lang.Confirm)}
        </Button>
      {/if}
    </div>
  </Modal>
</div>
